import { showModal } from 'modal.react.js';

import { SafariPortalIconStyles } from 'constants/fontAwesome';

import { AModal } from '../../../../../../../../../../shared/AModal';
import area from '../../../../../../../../../../shared/GlobalModalArea/area';
import { FONT_AWESOME_ICON_STYLES } from './constants';
import * as types from './types';

import IconSearch from './index';

interface IconSearchReturn {
  selectedIcon: string;
  isFavorite?: boolean;
}

export function openIconSearch({
  isImprovedUIOnEventModalsFeature = false,
}: {
  isImprovedUIOnEventModalsFeature?: boolean;
}) {
  return showModal<IconSearchReturn | null>(area, (res) => {
    return (
      <AModal
        header="Search Icons"
        headerPlacement="center"
        onReturn={() => res(null)}
        isOpen
        withoutCloseBtn
        withoutBackdrop
        size={isImprovedUIOnEventModalsFeature ? 'xlg' : 'lg'}
      >
        <IconSearch toClose={res} />
      </AModal>
    );
  });
}

export const getFilteredIcons = (data: types.IIconSearchResult[]): types.HandledIcons => {
  const solidIcons = data.filter((icon) => icon.style === SafariPortalIconStyles.SOLID);
  const regularIcons = data.filter((icon) => icon.style === SafariPortalIconStyles.REGULAR);
  const lightIcons = data.filter((icon) => icon.style === SafariPortalIconStyles.LIGHT);
  const thinIcons = data.filter((icon) => icon.style === SafariPortalIconStyles.THIN);
  const customIcons = data.filter((icon) => !FONT_AWESOME_ICON_STYLES.has(icon.style));

  return {
    [SafariPortalIconStyles.SOLID]: solidIcons,
    [SafariPortalIconStyles.REGULAR]: regularIcons,
    [SafariPortalIconStyles.LIGHT]: lightIcons,
    [SafariPortalIconStyles.THIN]: thinIcons,
    [SafariPortalIconStyles.CUSTOM]: customIcons,
  };
};
